import axiosInstance from "./AxiosInstance"

export function getKarmas(
  pagination = false,
  pageid = 0,
  search_by = "",
  search_keyword = "",
  sort_order = "",
  sort_by = "",
) {
  return axiosInstance.post("/panchkarma/karmaList", {
    pagination,
    pageid,
    search_by,
    search_keyword,
    sort_order,
    sort_by,
  })
}

export function createKarma(data) {
  return axiosInstance.post("/panchkarma/addKarma", data)
}

export function updateKarma(data) {
  return axiosInstance.post("/panchkarma/addKarma", data)
}

export function deleteKarma(karma_id) {
  return axiosInstance.post("/panchkarma/delete", { karma_id })
}

export function formatKarmas(responseData) {
  if (!responseData) return []
  const arrayData = Array.isArray(responseData) ? responseData : Object.values(responseData)

  return arrayData.map((k, key) => {
    let todos = []
    if (Array.isArray(k.todos)) {
      todos = k.todos
    } else if (typeof k.todos === "string") {
      try {
        const parsed = JSON.parse(k.todos || "[]")
        todos = Array.isArray(parsed) ? parsed : []
      } catch {
        todos = []
      }
    }

    return {
      id: k.karma_id ?? key,
      karma_id: k.karma_id,
      karma_name: k.karma_name,
      karma_duration_in_days: k.karma_duration_in_days,
      karma_depends_on: k.karma_depends_on,
      karma_charges: k.karma_charges,
      karma_status: k.karma_status,
      karma_description: k.karma_description,
      karma_benefits: k.karma_benefits,
      karma_precautions: k.karma_precautions,
      karma_instructions: k.karma_instructions,
      todos,
      created_at: k.created_at,
      updated_at: k.updated_at,
    }
  })
}
